import React, {Component} from "react";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import Card from "../../common/Card";
import {Collapse} from "antd";
import './Fleetback.css'
import Badge from "../../common/badge/Badge";
import FleetbackIntervention from "./FleetbackIntervention";

const { Panel } = Collapse;



class Fleetback extends Component {

  constructor(props){
    super(props)
  }

  onSendClick = (intervention) => {
    this.props.sendIntervention({fleetbackReference:intervention.reference});
  }


  header = (intervention)=>{
    const {intl:{formatMessage}} = this.props;
    const paid = intervention.payment && intervention.payment.status === 'SUCCEED'
    return(
      <header className="fleetback-panel-header">
        <div>{intervention.reference}</div><div>{intervention.paid === true && <Badge>€</Badge>}<Badge>{formatMessage({id:`fleetback.intervention.status.${intervention.status}`})}</Badge></div>
      </header>)

  }

  render() {
    const {intl:{formatMessage}, fleetbackInterventions} = this.props;

    if (!fleetbackInterventions || (Array.isArray(fleetbackInterventions) && fleetbackInterventions.length === 0)){
      return null;
    }

    return (
      <Card title={`Fleetback (${fleetbackInterventions.length})`}>
        <Collapse defaultActiveKey={[fleetbackInterventions[0].fleetbackId]}>
          {fleetbackInterventions.map(i=> <Panel header={this.header(i)} key={i.fleetbackId}>
            <FleetbackIntervention key={i.fleetbackId} fleetbackIntervention={i}/>
          </Panel>)}
        </Collapse>

      </Card>
    );
  }
}

const mapStateToProps = state => ({
  fleetbackInterventions: state.fleetbackInterventions.payload,
})

const mapDispatchToProps = dispatch => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(Fleetback))



// WEBPACK FOOTER //
// ./src/components/interventiondetail/fleetback/Fleetback.js